var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "depth-table",
      class: { "show-all": _vm.isShowAll, sell: _vm.dataType === "sell" }
    },
    [
      _c(
        "div",
        { ref: "depthTable", staticClass: "depth-table-wrapper" },
        [
          _c("loading", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "ex-center-loading",
            attrs: { loadingType: "dot" }
          }),
          _vm._v(" "),
          !_vm.isShowAll && _vm.dataType === "buy"
            ? _c("price", { staticClass: "border_b" })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.depthData, function(item, i) {
            return _c(
              "div",
              {
                key: i,
                ref: "depthRow" + i,
                refInFor: true,
                staticClass: "__center-tb-row __pointer",
                class: {
                  in_mining: _vm.miningSeparatorArr.indexOf(i) !== -1,
                  border_b:
                    (_vm.miningSeparator >= 0 &&
                      _vm.dataType === "buy" &&
                      i === _vm.miningSeparator) ||
                    (_vm.dataType === "buy" && _vm.selectIndex === i),
                  border_t:
                    (_vm.miningSeparator >= 0 &&
                      _vm.dataType === "sell" &&
                      i === _vm.miningSeparator) ||
                    (_vm.dataType === "sell" && _vm.selectIndex === i),
                  in_select_range: _vm.isInRange(i),
                  selected_row: i === _vm.selectIndex
                },
                on: {
                  click: function($event) {
                    return _vm.clickRow(item, i)
                  },
                  mouseenter: function($event) {
                    return _vm.showTips(item, i)
                  },
                  mouseleave: function($event) {
                    return _vm.hideTips(item)
                  }
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "__center-tb-item depth price __ellipsis",
                    class: _vm.dataType
                  },
                  [
                    _vm.isInOpenOrders(item.price)
                      ? _c("span", { staticClass: "owner" })
                      : _c("span", { staticClass: "not-owner" }),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("depthFormatNum")(
                            item.price,
                            _vm.quoteTokenDepthDigit
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "__center-tb-item left depth quantity" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("depthFormatNum")(
                          item.quantity,
                          _vm.tradeTokenDigit
                        )
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "__center-tb-item depth amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("depthFormatNum")(item.amount, _vm.quoteTokenDigit)
                    )
                  )
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "percent-wrapper",
                  class: _vm.dataType,
                  style: { width: _vm.getWidth(item) + "%" }
                })
              ]
            )
          }),
          _vm._v(" "),
          !_vm.isShowAll && _vm.dataType === "sell"
            ? _c("price", {
                class: {
                  border_all: _vm.depthData.length,
                  border_b: !_vm.depthData.length
                }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }